export const INIT_LISTE = 'INIT_LISTE'
export const UPDATE_SCORE = 'UPDATE_SCORE'
export const UNDO_SCORE = 'UNDO_SCORE'
